import { useEffect } from 'react'
import { io } from 'socket.io-client'

import { useUser } from './use-user.hook'
import { IUserOnlineEventPayload } from 'src/types'

import { STORAGE_KEYS, WS_EVENTS_KEYS, WS_NAMESPACES_KEYS } from 'src/constants'

const useSetOnlineStatus = () => {
  const { data: user } = useUser()

  useEffect(() => {
    if (!user) return

    const payload: IUserOnlineEventPayload = {
      userId: user.id,
      refreshToken: localStorage.getItem(STORAGE_KEYS.REFRESH_TOKEN)!,
    }

    const socket = io(
      process.env.REACT_APP_BACKEND_URL + '/' + WS_NAMESPACES_KEYS.USER_ONLINE_STATUS,
    )
    socket.emit(WS_EVENTS_KEYS.USER_ONLINE, payload)

    return () => {
      socket.disconnect()
    }
  }, [user])
}

export { useSetOnlineStatus }
